(function () {
  'use strict';

  var activeGuide = null;

  function openSizeGuide(modal, trigger) {
    if (!modal || !modal.parentNode) return;
    if (activeGuide && activeGuide.modal === modal) return;
    if (activeGuide) closeSizeGuide(false);

    var placeholder = document.createComment('nfp-size-guide-location');
    modal.parentNode.insertBefore(placeholder, modal);

    activeGuide = {
      modal: modal,
      placeholder: placeholder,
      trigger: trigger,
      previousOverflow: document.documentElement.style.overflow
    };

    // Move the popup outside the product section to prevent clipping.
    document.body.appendChild(modal);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    modal.scrollTop = 0;

    var dialog = modal.querySelector('.nfp-size-guide-modal__dialog');
    if (dialog) dialog.scrollTop = 0;

    var closeButton = modal.querySelector('[data-nfp-size-guide-close]');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function closeSizeGuide(restoreFocus) {
    if (!activeGuide) return;

    var guide = activeGuide;
    activeGuide = null;

    guide.modal.classList.remove('is-open');
    guide.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = guide.previousOverflow;

    if (guide.placeholder.isConnected) {
      guide.placeholder.parentNode.replaceChild(
        guide.modal,
        guide.placeholder
      );
    } else {
      guide.modal.remove();
    }

    if (
      restoreFocus !== false &&
      guide.trigger &&
      guide.trigger.isConnected
    ) {
      guide.trigger.focus({ preventScroll: true });
    }
  }

  // Handles existing links and product blocks refreshed by Shopify.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var trigger = target.closest('[data-nfp-size-guide-open]');

    if (trigger) {
      event.preventDefault();

      if (activeGuide && activeGuide.trigger === trigger) return;

      var wrapper = trigger.closest('.nfp-size-guide');
      var modal = wrapper &&
        wrapper.querySelector('[data-nfp-size-guide-modal]');

      openSizeGuide(modal, trigger);
      return;
    }

    if (!activeGuide) return;

    var closeButton = target.closest('[data-nfp-size-guide-close]');

    if (
      target === activeGuide.modal ||
      (closeButton && activeGuide.modal.contains(closeButton))
    ) {
      event.preventDefault();
      closeSizeGuide(true);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!activeGuide) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeSizeGuide(true);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = Array.from(
      activeGuide.modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), ' +
        '[tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.getClientRects().length > 0 &&
        element.tabIndex >= 0;
    });

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (activeGuide && event.target.contains(activeGuide.placeholder)) {
      closeSizeGuide(false);
    }
  });

  function findProductSubmitButton() {
    return document.querySelector(
      'form[action*="/cart/add"] button[name="add"], ' +
      'product-form button[name="add"], .product-form__submit'
    );
  }

  function scrollToProductForm() {
    var target =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form') ||
      document.querySelector('.product__info-container');

    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  function initMobileAtc() {
    var sticky = document.querySelector('[data-nfp-mobile-atc]');

    if (!sticky || sticky.dataset.nfpReady === 'true') return;
    sticky.dataset.nfpReady = 'true';

    var button = sticky.querySelector('[data-nfp-mobile-atc-button]');
    var offset = parseInt(
      sticky.getAttribute('data-scroll-offset'),
      10
    ) || 450;

    function updateVisibility() {
      if (window.innerWidth > 749) {
        sticky.classList.remove('is-visible');
        return;
      }

      if (window.scrollY > offset) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }

    if (button) {
      button.addEventListener('click', function () {
        var submitButton = findProductSubmitButton();

        if (submitButton && !submitButton.disabled) {
          submitButton.click();
        } else {
          scrollToProductForm();
        }
      });
    }

    window.addEventListener('scroll', updateVisibility, {
      passive: true
    });
    window.addEventListener('resize', updateVisibility);

    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileAtc, {
      once: true
    });
  } else {
    initMobileAtc();
  }

  document.addEventListener('shopify:section:load', initMobileAtc);
})();